import { cx } from '@emotion/css'
import React from 'react'
import styles from './styles'

const adaptFileEventToValue = delegate => e => delegate(e)

const MultiUpload = props => {
  const {
    input: { value: omitValue, onChange, onBlur, ...inputProps },
    className,
    label,
    buttonText,
  } = props

  return (
    <label htmlFor="file" className={cx(styles.container, className)}>
      <input
        className={styles.fileInput}
        id="file"
        onChange={adaptFileEventToValue(onChange)}
        onBlur={adaptFileEventToValue(onBlur)}
        type="file"
        {...inputProps}
      />
      <span className={styles.label}>{label || 'Upload file'}</span>
      <span className={styles.button}>{buttonText || 'Upload files'}</span>
    </label>
  )
}

export default MultiUpload
